import { IMensaje } from '../interface/IMensaje';
import { bd , firebaseAdmin } from './Firestore.config';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { IGuia } from '../interface/IGuia';


export const guardarMensaje = (obj:IMensaje,guia:string) => {
    const doc = bd.collection(`Chat/${guia}/Chat`).doc();
    doc
        .set({
            ...obj
        })
        .then();
}

export const finalizarChat = (guia:string):Promise<void> => {
  const doc = bd.collection(`Chat`).doc(guia);
  return doc.update({
    estado:'FINALIZADO',
    fecha_fin: firebaseAdmin.firestore.FieldValue.serverTimestamp(),
  }).then();
}

export const obtenerGuiaPorToken = async(token:string):Promise<string> => {
  const doc = bd.collection(`Token-Guia`).doc(token);
  const document = await doc.get();
  const guia = document.data();
  return guia ? guia['guia'] : '';
}

export const soporteAdicional = (guia:IGuia):Promise<void> => {
  const doc = bd.collection(`Chat`).doc(guia.guia);
  const mensaje:IMensaje = {
    Remitente:'Cliente',
    Isseen:{
      "Cliente":true,
      "Repartidor":false,
      "Asesor1":false
    },
    Timestamp:firebaseAdmin.firestore.FieldValue.serverTimestamp(),
    Type:'ALERTA_SOPORTE',
    Mensaje:'Se ha solicitado soporte adicional por parte del DESTINATARIO'
  }
  guardarMensaje(mensaje,guia.guia)
  return doc.update({
    soporte_adicional:true,
    fecha_soporte: firebaseAdmin.firestore.FieldValue.serverTimestamp(),
  }).then();
}

export const soporteAdicionalGuia = (guia:string):Promise<void> => {
  const doc = bd.collection(`Chat`).doc(guia);
  return doc.update({
    soporte_adicional:true,
    soporte_entrega_fallida:false,
    fecha_soporte:firebaseAdmin.firestore.FieldValue.serverTimestamp()
  }).then();
}

export const actualizarMensaje = (guia:string,mensajes:IMensaje[]):Promise<void> => {
  const isseen:any = {};
    const batch = bd.batch()
    const documents = mensajes.map((m) => bd.collection(`Chat/${guia}/Chat`).doc(m.Doc))
    for (let i = 0; i < documents.length; i++) {
      isseen['Isseen.Cliente']=true;
      batch.update(documents[i],isseen)
    }
    return batch.commit();
}

export const obtenerMensajes = (codigo_remision:string):Observable<IMensaje[]> => {
    return Observable.create((observer:any) => bd
        .collection(`Chat/${codigo_remision}/Chat`)
        .orderBy('Timestamp','asc')
        .onSnapshot(observer)
      ).pipe(
          map((data:firebase.firestore.QuerySnapshot) => {
            return data.docs.map((d:any) => {
              if (d.data().Timestamp) {
                const doc = d.data()
                const mensaje:IMensaje = {
                  Doc:d.id,
                  Type:doc.Type ? doc.Type : 'TEXT',
                  Mensaje:doc.Mensaje,
                  Remitente:doc.Remitente,
                  Isseen:doc.Isseen,
                  Timestamp:doc.Timestamp.toDate().toString()
                }
                if (doc.Nombre_Empleado) mensaje.Nombre=doc.Nombre_Empleado
                return mensaje
              }
              return [];
          })
          } 
        )
    )
}

export const obtenerGuia = (codigo_remision:string):Observable<IGuia> => {
    return Observable.create((observer:any) => bd
        .collection(`Chat`)
        .doc(codigo_remision)
        .onSnapshot(observer)
      ).pipe(
          map((data:firebase.firestore.QueryDocumentSnapshot) => {
            return data.data() as IGuia;
          }
        )
    )
}